import axios from "axios";
import React from "react";
import Popup from "../components/popup";
import 'bootstrap/dist/css/bootstrap.css';
import OrderComplete from "../components/ordercompleteButton";
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));

export default class OrderPage extends React.Component {
  state = {
    carts: [],
    costs: [],
    order: []
  }

  componentDidMount() {
    axios.get(`https://shoppee-clone.herokuapp.com/user/${loggedInUserID}/cartitem`)
      .then(res => {
        console.log(res.data)
        const carts = res.data;
        this.setState({ carts });
      })
    axios.get(`https://shoppee-clone.herokuapp.com/user/${loggedInUserID}/totalprice`)
      .then(res => {
        const costs = res.data;
        console.log(res.data)
        this.setState({ costs });
      })
      .catch(error => {

        console.log(error)
      })
    axios.get(`https://shoppee-clone.herokuapp.com/user/${loggedInUserID}/order`)
      .then(res => {
        const order = res.data;
        console.log(res.data)
        this.setState({ order });
      })
      .catch(error => {

        console.log(error)
      })
  }

  render() {
    return (

      <div>
        <div className="billinginfo card border border-dark ">
          {this.state.order.map(post =>
            <div className="row">
              <div className="col-12">
                <div className="card-body">
                  <div className="d-flex justify-content-start">
                    <h2>Billing Information</h2>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="mt-4">
                        <div className="row">
                          <div className="col-sm-3 col-md-4 col-1">
                            <label className="">Full Name</label>
                          </div>
                          <div className="col-md-8">{post.username}</div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-sm-3 col-md-4 col-5">
                            <label className="item-label">Email</label>
                          </div>
                          <div className="col-md-8">{post.email}</div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-sm-3 col-md-4 col-1">
                            <label className="item-label">Phone No.</label>
                          </div>
                          <div className="col-md-8">{post.contact}</div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-sm-3 col-md-4 col-5">
                            <label className="item-label">Address</label>
                          </div>
                          <div className="col-md-8 col-6">{post.address}</div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.order.map(order =>
            <div className="row ">
              <div>&nbsp;&nbsp;&nbsp;&nbsp;Payment Method:&nbsp;&nbsp;************{order.cardno} &nbsp;&nbsp;&nbsp;&nbsp;</div>
            </div>
          )}
        </div>
        <div className="ordercard card border border-dark">
          <h2 ><i class="ordericon bi bi-basket3"></i></h2>
          {this.state.carts.map(carts =>
            <div >
              <div className="card-body">
                <p className="orderdetails">{carts.productname}&nbsp;Qty: {carts.qty}&nbsp;${carts.price}</p>
              </div>
            </div>
          )}
          <hr />
          {this.state.costs.map(costs =>
            <div>
              <h4>&nbsp;&nbsp;&nbsp;Total:&nbsp;${costs.totalprice}</h4>
            </div>
          )}
        </div>
        <OrderComplete />
      </div>
    )
  }
} 
